export default __webpack_public_path__ + "static/media/quarto3.0723772a.jpg";